module.exports = __webpack_public_path__ + "img/switch_account.e2cae0a2.png";